import React from "react";
import { Button, NumberInput, required, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";

const validatePercentageSum = (value, allValues) => {
  const sum =
    (Number(allValues.trainerPercentage) || 0) +
    (Number(allValues.bapzgPercentage) || 0) +
    (Number(allValues.universityPercentage) || 0);
  if (sum !== 100) return "Сбора на процентите трябва да е точно 100%";
};

const NewVersionDialog = ({ onSuccess }) => {
  const notify = useNotify();

  const handleConfirm = async data => {
    await dataProvider.customRequest(specialistRequests.postHealthcareCourseFeeDistribution(), data, "POST");
    notify("Версията е обновена успешно", { type: "success" });
    onSuccess();
  };

  return (
    <FormModal
      onConfirm={handleConfirm}
      titleContent="Нова версия на разпределение на такси"
      triggerButton={
        <Button
          startIcon={<AddIcon />}
          variant="outlined"
          label="Нова версия"
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="trainerPercentage"
            label="Процент за обучаващ"
            validate={[required(), validatePercentageSum]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="bapzgPercentage"
            label="Процент за БАПЗГ"
            validate={[required(), validatePercentageSum]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="universityPercentage"
            label="Процент за Университет"
            validate={[required(), validatePercentageSum]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="effectiveFrom"
            label="В сила от"
            validate={required()}
            noTime
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default NewVersionDialog;
